<template>
  <v-dialog v-model="show" width="600px">
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text class="text-xs-center">{{
        content || 'Are you sure?'
      }}</v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="confirm">{{ action || 'はい' }}</v-btn>
        <v-btn @click="cancel">{{ rejectAction || '戻る' }}</v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      title: null,
      content: null,
      resolve: null,
      reject: null,
      action: null,
      rejectAction: null,
    }
  },
  methods: {
    popup({ title, content, action, resolve, reject, rejectAction }) {
      this.show = true
      this.title = title
      this.content = content
      this.action = action
      this.rejectAction = rejectAction
      this.resolve = resolve
      this.reject = reject
    },
    confirm() {
      this.show = false
      this.resolve('ok')
    },
    cancel() {
      this.show = false
      this.reject('cancel')
    },
  },
}
</script>
